import React from 'react';

import type { Dispensaries } from 'src/gql/graphql';
import MediaQuery from 'shared/components/media-query';
import { DesktopHeader } from './desktop-header';
import { MobileHeader } from './mobile-header';
import { InfoBar } from './info-bar';
import { InfoBarMq } from './header.styles';
import { LoginNudgeProvider } from './login-nudge/login-nudge-context';

type NavigationProps = {
  dispensary: Dispensaries;
  isAccountEnabled: boolean;
};

export const Navigation = ({ dispensary, isAccountEnabled }: NavigationProps): JSX.Element => (
  <>
    <LoginNudgeProvider>
      <MediaQuery mediaQuery='@media (min-width: 880px)'>
        <DesktopHeader dispensary={dispensary} isAccountEnabled={isAccountEnabled} />
      </MediaQuery>
      <MediaQuery mediaQuery='@media (max-width: 879px)'>
        <MobileHeader dispensary={dispensary} isAccountEnabled={isAccountEnabled} />
      </MediaQuery>
    </LoginNudgeProvider>

    <InfoBarMq>
      <InfoBar />
    </InfoBarMq>
  </>
);
